import SavedForLaterInSideCartPage from "@faire/prototype-playground/workspace/nt/sfl-in-side-cart";
import { Route, Switch } from "react-router-dom";

export function NikitaTashchilinRoutes() {
  return (
    <Switch>
      <Route
        path="/nt/sfl-in-side-cart"
        component={SavedForLaterInSideCartPage}
      />
    </Switch>
  );
}

export const slug = "nt";
